{"browse_shop":"Разгледай магазина","go_to_shop":"Към магазина","no_orders_found":"Няма намерени поръчки","title":"Поръчки"}